import Vue from "vue";
import Router from "vue-router";
import * as pages from "./pages";
import * as agency from "./modules/Agency";
import * as statics from "./modules/Static";
import Welcome from "./modules/NewOnboarding/views/BaseLayout";
import PageNotFound from "@/pages/PNF.vue";
import EmptyView from "@/core/components/EmptyView.vue";
import i18n, { loadLanguageAsync } from "./i18n";
import { routerRedirects } from "./utils/routerRedirects";
// import Cookie from "./utils/cookie";
// import { GEM_LANG_COOKIE_NAME } from "./config/constants";
// import * as agencysignin from "./modules/AgencySignin";
// import * as modules from "./modules";

let routes = [];

const requireComponent = require.context(
  // The relative path of the components folder
  "./modules",
  // Whether or not to look in open subfolders
  true,
  /^\.\/[A-Za-z]+\/$/
);

requireComponent.keys().forEach(fileName => {
  const _module = requireComponent(fileName);
  const exception = ["./Agency/", "./AgencySignin/", "./Static/"];
  exception;
  // if ((fileName != "./Agency/") && (fileName != "./AgencySignin/"))
  if (!exception.includes(fileName)) routes.push(..._module.routes.default);
});

Vue.use(Router);

const router = new Router({
  mode: "history",
  linkActiveClass: "rl-active",
  linkExactActiveClass: "rl-eactive",
  base: "/",
  routes: [
    {
      path: "",
      redirect: () => {
        return {
          name: "Dashboard"
        };
      }
    },
    {
      path: "/",
      component: pages.EmptyLayout,
      children: statics.routes.default
    },
    {
      path: "/welcome",
      name: "Welcome",
      component: Welcome,
    },
    {
      path: "/install",
      component: pages.Login
    },
    {
      path: "/agency",
      component: EmptyView,
      children: [
        {
          path: "",
          redirect: {
            name: "AgencyDashboard"
          },
          name: "AgencyRoot"
        },
        ...agency.routes.default
      ]
    },
    {
      path: "/",
      component: pages.Root,
      children: [
        {
          path: "",
          redirect: {
            name: "Dashboard"
          },
          name: "Root"
        },
        ...routes,
        {
          path: "*",
          component: PageNotFound,
          meta: {
            headerVisible: false
          }
        }
      ]
    }
    // {
    //   path: "*",
    //   name: "Fallback",
    //   component: pages.PNF
    // }
  ]
});
router.beforeEach((to, from, next) => {
  // console.error("Lang in cookie", Cookie.get(GEM_LANG_COOKIE_NAME))
  const lang = i18n.locale || process.env.VUE_APP_I18N_LOCALE || "en";
  loadLanguageAsync(lang).finally(() => {
    next();
  })
  routerRedirects(to, from, next)
})

export default router;
